module.exports = __webpack_public_path__ + "static/media/chevron-up.2f2c3c86.svg";